import NAVIGATION from '@/constant/navigation.js';
import getDeviceInfo from '@/lib/base/getDeviceInfo';
import {GAME_MODES} from '@/constant/chessboard';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/play',
    name: 'play',
    component: () => import('@/views/Play/index.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.PLAY,
    },
  },
  {
    path: '/play/npc-list',
    name: 'npc-list',
    component: () => import('@/views/Play/NpcList.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.PLAY,
    },
  },
  {
    path: '/play/npc-list/game',
    name: 'npc-game',
    component: () => import('@/views/Room/GameRoom.vue'),
    props: {mode: GAME_MODES.KOL},
    meta: {
      hasNavigation: false,
      fromUpperTransitionType: 'passAnimation',
      toUpperTransitionType: 'slide',
      passAnimationMode: 'game',
      requireAuth: true,
      chessboardRoom: true,
    },
  },
];
